import { FuseAnimate, FusePageCarded } from "@fuse";
import _ from "@lodash";
import { Checkbox, FormControl, FormControlLabel, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import XAPPChipSelect from "app/Core/Components/ChipSelect/XAPPChipSelect";
import LookupApp from "app/Core/Components/Lookup/LookupApp";
import MigrarCadastro from "app/Core/Components/MigrarCadastro/MigrarCadastro";
import PesquisaPainel from "app/Core/Components/PesquisaPainel/PesquisaPainel";
import TogglePesquisa from "app/Core/Components/PesquisaPainel/TogglePesquisa";
import ToggleFiltro from "app/Core/Components/ToggleFiltro/ToggleFiltro";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import OnboardingToggle from "app/Core/Funcionalidade/Comunicador/Gerenciadores/Onboarding/OnboardingToggle";
import { ReplaceAll } from "app/Core/Helpers";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdHome, MdPerson } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import ArquivoReducer from "../../GED/Arquivo/Store/Reducers/ArquivoReducer";
import EmpresaPessoaDialog from "./EmpresaPessoaDialog";
import EmpresaPessoaList from "./EmpresaPessoaList";
import EmpresaPessoaSidebar from "./EmpresaPessoaSidebar";
import * as Actions from "./Store/Actions/EmpresaPessoaActions";
import reducer from "./Store/Reducers";

const filtrosDisponiveis = [
    { "name": "nome", "label": "Nome", "value": "UPPER(pessoaformulario.formulario->>''nome'')", "tipo": "text", "segmento": "100, 200, 300, 400" },
    { "name": "documentoprimario", "label": "CPF / CNPJ", "value": "pessoaformulario.formulario->>''documentoprimario''", "tipo": "number", "segmento": "100, 200, 300" },
];

const styles = theme => ({
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class EmpresaPessoaApp extends XAPPComponent {

    state = {
        acoes: null,
        conditions: null,
        showinativo: false
    };

    componentWillUnmount() {
        const { isLookup, isButton } = this.props;
        if (!isLookup && !isButton) {
            this.props.clearReducer();
        }
    }

    getAcoes = () => {
        return this.state.acoes;
    };

    setAcoes = (_AValue) => {
        this.setState({ acoes: _AValue });
    };

    setConditions = (_AValue) => {
        this.setState({ conditions: _AValue });
    };

    listFilter = (_AFilter, _ATarget = null, _APagina = 1, _ACallback = null) => {
        let { xappRouteParams, target = null, customTags = "pessoa" } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        this.props.list("SELECIONAR", { ...xappRouteParams, customTags }, _AFilter, _APagina, !_.isNull(_ATarget) ? _ATarget : target, _ACallback);
    };

    pesquisar = (_AUseFiltro = true) => {
        this.listFilter(this.getFiltro(_AUseFiltro));
        if (!_.isUndefined(this.PesquisaPainel)) {
            this.PesquisaPainel.togglePainel("empresapessoa", _AUseFiltro ? this.getCountFiltro() : 0, this.clearFiltro);
        }
    };

    clearFiltro = () => {
        let form = {};
        filtrosDisponiveis.forEach(item => {
            form[item.name] = null;
        });
        form.showinativo = false;
        form.tags = null;
        this.setState(_.set({ ...form }));
        this.pesquisar(false);
    };

    getFiltro = (_AUseFiltro = true) => {
        const form = this.state;
        var AArray = [];
        if (_AUseFiltro) {
            filtrosDisponiveis.forEach(item => {
                if (!_.isUndefined(form[item.name]) && !_.isNull(form[item.name]) && form[item.name].length > 0) {
                    AArray.push({ "Campo": item.value, "Operador": (item.tipo === "text" ? "LIKE" : "="), "Valor": form[item.name] });
                }
            });
            if (form.showinativo) {
                AArray.push({ "Campo": "pessoaformulario.statusregistro", "Operador": ">", "Valor": -5 });
            }
            if (form.tags && form.tags.length > 0) {
                AArray.push({ "Campo": "tags", "Operador": "=", "Valor": ReplaceAll(ReplaceAll(form.tags, "{", ""), "}", "") });
            }
        }
        return { AND: AArray };
    };

    getCountFiltro = () => {
        const form = this.state;
        var AResult = 0;
        filtrosDisponiveis.forEach(item => {
            if (!_.isUndefined(form[item.name]) && !_.isNull(form[item.name]) && form[item.name].length > 0) {
                AResult++;
            }
        });
        if (form.showinativo) {
            AResult++;
        }
        if (form.tags && form.tags.length > 0) {
            AResult++;
        }
        return AResult;
    };

    handleChange = (ev) => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.type === "checkbox" ? ev.target.checked : ev.target.value));
    };

    getIconHeader = () => {
        const { icone } = this.props;
        switch (icone) {
            case "imovel": return <MdHome className="text-24 text-white mx-8" />;
            default: return <MdPerson className="text-24 text-white mx-8" />;
        }
    };

    getData = () => {
        const { Pessoas, defaultTipo = [] } = this.props;
        const { data = null } = Pessoas;
        let AResponse = [];
        if (!_.isNull(data)) {
            AResponse = _.filter(data, x => {
                let ACheck = true;
                defaultTipo.forEach(y => {
                    if (!x.formulario.tipo.includes(y)) {
                        ACheck = false;
                    }
                });
                return ACheck;
            });
        }
        return AResponse;
    };

    getTags = () => {
        const { TagsPessoa = null } = this.props;
        let AResponse = [];
        if (!_.isNull(TagsPessoa)) {
            TagsPessoa.forEach(tag => {
                AResponse.push({ ...tag, "id": tag.idtagpessoaformulario, "nome": tag.tagnome });
            });
        }
        return AResponse;
    };

    renderListagem() {
        const { multiSelect, TagsPessoa = null, user, isLookup, openProntuario, classes, onChange, customTags = "pessoa", selected, isButton, disablePersonFields, label = null, target = null } = this.props;
        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        const form = this.state;

        return (
            <React.Fragment>
                <PesquisaPainel
                    id="empresapessoa"
                    anchor="left"
                    onRef={instance => this.PesquisaPainel = instance}
                >
                    <div className={"flex flex-col p-12 text-center items-center"}>
                        {_.uniqBy(_.filter(filtrosDisponiveis, x => x.segmento.split(", ").includes(user.settings.tipo)), "name").map((item, x) => (
                            <TextField
                                key={x}
                                className="mb-12"
                                id={item.name}
                                name={item.name}
                                label={item.label}
                                value={!_.isNull(form[item.name]) ? form[item.name] : ""}
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                type={item.tipo}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        ))}
                        <XAPPChipSelect
                            array={!_.isNull(TagsPessoa) ? this.getTags() : []}
                            id={"tags"}
                            label={"Tags"}
                            onChange={this.handleChange}
                            select={form.tags}
                            className="mb-24 w-full"
                        />
                        <FormControl className={"w-full"}>
                            <FormControlLabel
                                className={"mx-0"}
                                control={
                                    <Checkbox
                                        className="p-6 mr-8"
                                        name={"showinativo"}
                                        type='checkbox'
                                        checked={form.showinativo}
                                        onChange={this.handleChange}
                                    />
                                }
                                label={"Mostrar inativos"}
                            />
                        </FormControl>
                    </div>
                    <div className="flex p-12 gap-6">
                        <div className="flex-1" />
                        <XAPPButton
                            className="text-white"
                            label="Limpar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="close"
                            iconProps="text-20 mr-8"
                            onClick={() => this.clearFiltro()}
                        />
                        <XAPPButton
                            className="text-white"
                            label="Pesquisar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="search"
                            iconProps="text-20 mr-8"
                            onClick={() => this.pesquisar()}
                        />
                    </div>
                </PesquisaPainel>
                <CatchErro
                    url={this.props.match.url}
                >
                    {!isButton &&
                        <FusePageCarded
                            classes={{
                                contentWrapper: "p-0",
                                //contentCardWrapper: "p-16 sm:p-24 pb-80",
                                header: "w-full min-h-48 h-48 max-h-48 flex",
                                sidebarHeader: "min-h-48 h-48",
                                topBg: "min-h-48 h-48"
                            }}
                            header={
                                <div className="w-full flex items-center">
                                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                        <Typography className="flex text-white items-center capitalize" variant="h6">
                                            {this.getIconHeader()}
                                            {!_.isNull(label) ? label : "Pessoas"}
                                        </Typography>
                                    </FuseAnimate>
                                    <div className="flex-1" />
                                    <OnboardingToggle
                                        empresa={xappRouteParams.empresa}
                                    />
                                    <MigrarCadastro xappRouteParams={xappRouteParams} tipo="paciente" className="text-white" />
                                    <TogglePesquisa id={"empresapessoa"} />
                                    <ToggleFiltro toggleRightSidebar={!_.isUndefined(this.pageLayout) && this.pageLayout.toggleRightSidebar} />
                                </div>
                            }
                            rightSidebarHeader={
                                <div />
                            }
                            rightSidebarContent={
                                <div id="rightSidebarContent">
                                    <EmpresaPessoaSidebar
                                        setcondicoes={this.setConditions}
                                        customTags={customTags}
                                    />
                                </div>
                            }
                            content={
                                <React.Fragment>
                                    {!isButton ?
                                        <EmpresaPessoaList
                                            isLookup={isLookup}
                                            filter={this.getFiltro()}
                                            xappRouteParams={xappRouteParams}
                                            setAcoes={this.setAcoes}
                                            getAcoes={this.getAcoes}
                                            conditions={this.state.conditions}
                                            target={target}
                                            onChange={onChange}
                                            selected={selected}
                                            multiSelect={multiSelect}
                                            listFilter={this.listFilter}
                                            openProntuario={openProntuario}
                                            disablePersonFields={disablePersonFields}
                                        />
                                        :
                                        <div />
                                    }
                                </React.Fragment>
                            }
                            sidebarInner
                            onRef={instance => {
                                this.pageLayout = instance;
                            }}
                            innerScroll
                        />
                    }
                    {!isButton && !isLookup &&
                        <XAPPButton
                            id={"fab-add-pessoa"}
                            className={classes.addButton}
                            type="Fab"
                            variant="contained"
                            color="primary"
                            iconProps="text-24 text-white"
                            onClick={() => this.props.openNewDialog()}
                            icon={"add"}
                        />
                    }
                </CatchErro>
            </React.Fragment>
        );
    }

    renderLookup() {
        const { multiSelect, autoSearch, selectFirstAuto, showNovo = true, openNewDialog, onChange, label = null, required, selected, className, id, readOnly, campoid = null, target = null, camponome = null } = this.props;
        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <LookupApp
                    className={className}
                    label={label}
                    id={id}
                    multiSelect={multiSelect}
                    onChange={onChange}
                    required={required}
                    options={this.getData()}
                    selected={selected}
                    listagem={this.renderListagem()}
                    pesquisar={this.listFilter}
                    xappRouteParams={xappRouteParams}
                    campoid={!_.isNull(campoid) ? campoid : "idpessoaformulario"}
                    camponome={!_.isNull(camponome) ? camponome : "nome"}
                    filtrodescricao={"UPPER(pessoaformulario.formulario->>''nome'')"}
                    novo={showNovo ? openNewDialog : null}
                    readOnly={readOnly}
                    autoSearch={autoSearch}
                    selectFirstAuto={selectFirstAuto}
                    target={!_.isNull(target) ? target : "spvwempresapessoalookup"}
                />
            </React.Fragment>
        );
    }

    render() {
        const { isLookup, id, showNovo = true, isButton = false, callback = null, defaultTipo, isGestor = false, target = null, customTags = "pessoa", customFields = "pessoa", disablePersonFields } = this.props;

        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    {isLookup ?
                        <React.Fragment>
                            {this.renderLookup()}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {this.renderListagem()}
                        </React.Fragment>
                    }
                    {showNovo &&
                        <EmpresaPessoaDialog
                            xappRouteParams={xappRouteParams}
                            isGestor={isGestor}
                            isButton={isButton}
                            target={!_.isNull(target) ? target : "spvwempresapessoalookup"}
                            defaultTipo={defaultTipo}
                            customFields={customFields}
                            disablePersonFields={disablePersonFields}
                            callback={() => {
                                if (!_.isNull(callback)) {
                                    callback();
                                }
                                else {
                                    this.listFilter(this.getFiltro());
                                }
                            }}
                            customTags={customTags}
                            id={id}
                        />
                    }
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearReducer: Actions.clearReducer,
        list: Actions.list,
        get: Actions.get,
        openNewDialog: Actions.openNewDialog
    }, dispatch);
}

function mapStateToProps({ Pessoa, auth }) {
    return {
        Pessoas: Pessoa.EmpresaPessoaReducer,
        TagsPessoa: Pessoa.TagFuncionalidadeReducer["pessoa"],
        user: auth.user.data
    };
}

export default withReducer("Pessoa", reducer)(withReducer("ArquivoApp", ArquivoReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaApp)))));
